<template>
  <div>
    <div style="display:flex;align-items:center;margin-bottom:10px">
      <el-input size="small" placeholder="请输入内容" v-model="keyword" @keyup.enter.native="searchPro" style="margin-right:5px">
      </el-input>
      <div class="morandi-btn" @click="searchPro">搜索</div>
    </div>
    <div style="font-size:12px;color:#e67720;line-height:30px">
      {{autoSelect?'根据您当前操作的项目，已经默认为您选择推荐项目':'列表中项目为候选人所在项目，也可以搜索其他项目'}}
    </div>
    <div class="rp-attach-table">
      <el-row class="rp-table-head">
        <el-col :span="6">客户公司</el-col>
        <el-col :span="6">项目名称</el-col>
        <el-col :span="6">项目编号</el-col>
        <el-col :span="6">职能模块</el-col>
      </el-row>
      <div class="rp-attachs" style="max-height: calc(100vh - 440px);">
        <div v-for="(item, index) in projects" :key="index" @click="selectItem(item)" :id="item._id">
          <el-row class="rp-attach" :class="{'rp-attach-active':selected === item._id}">
            <el-col :span="6">{{ item.客户公司 }}</el-col>
            <el-col :span="6">{{ item.项目名称 }}</el-col>
            <el-col :span="6">{{ item.编号 }}</el-col>
            <el-col :span="6">{{ item.职能模块 }}</el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      rid: '',
      projects: [],
      radishProjects: [],
      selected: undefined,
      keyword: '',
      autoSelect: false,
    }
  },
  methods: {
    async init({rid, defaultSelectProject}) {
      this.rid = rid
      await this.loadRadishPro()
      if (defaultSelectProject) {
        defaultSelectProject.rid = rid
        this.selectItem(defaultSelectProject)
        this.$nextTick(()=>{
          document.getElementById(defaultSelectProject._id).scrollIntoView()
        })
        this.autoSelect = true
      }
    },
    async loadRadishPro() {
      const res = await app.service('radish').findProjectByRid({ rid: this.rid })
      if (res.status == 'success') {
        // const pMap = {
        //   推荐: 1,
        //   Call: 2,
        //   面试: 3,
        //   终面: 4,
        //   offer谈判: 5,
        //   离职辅导: 6,
        //   到岗: 7,
        //   过保: 8,
        //   未过保: 9,
        //   已放弃: 10,
        //   已淘汰: 10,
        // }
        // this.projects = this.radishProjects = res.data.sort((a, b) => {
        //   const pA = Array.isArray(a.人选进展阶段) ? a.人选进展阶段[0] : a.人选进展阶段
        //   const pB = Array.isArray(b.人选进展阶段) ? b.人选进展阶段[0] : b.人选进展阶段
        //   if (pMap[pA] < pMap[pB]) {
        //     return 1
        //   } else if (pMap[pA] == pMap[pB]) {
        //     return a.createdAt < b.createdAt ? 1 : -1
        //   } else {
        //     return -1
        //   }
        // }).map(item=>{
        //   item._id = item.pid
        //   return item
        // })
        this.projects = this.radishProjects = res.data.sort((a, b) => {
          const pA = Array.isArray(a.人选进展阶段) ? a.人选进展阶段[0] : a.人选进展阶段
          const pB = Array.isArray(b.人选进展阶段) ? b.人选进展阶段[0] : b.人选进展阶段
          if (a.推荐度 == '重点推荐') {
            return -1
          } else if (a.推荐度 != '重点推荐' && b.推荐度 == '重点推荐') {
            return 1
          } else if (pA != '推荐' && pB == '推荐') {
            return 1
          } else {
            return a.createdAt < b.createdAt ? 1 : -1
          }
        }).map(item=>{
          item._id = item.pid
          return item
        })
      } else {
        console.error(res.msg)
      }
    },
    async searchPro() {
      const keyword = this.keyword.trim().toLowerCase()
      if (keyword) {
        const pros = await app.service('project').search({ type: '项目', keywords: keyword })
        if (pros.status === 'success') {
          let proData = pros.data
          if (proData && proData.length > 0) {
            console.log(proData)
            if (this.rid) {
              const inData = this.radishProjects
              const inIds = inData.map(p => p.pid)
              proData.forEach(p => {
                if (inIds.includes(p._id)) {
                  p.rid = this.rid
                }
              })
            }
            return this.projects = proData
          }
        } else {
          console.error(pros.message)
        }
      }
      this.projects = this.radishProjects
    },
    selectItem(item) {
      this.selected = item._id
      this.autoSelect = false
      this.$emit('selectItem', item)
    },
  },
}
</script>
<style>
.radish-dia > .el-dialog > .el-dialog__body {
  padding: 0 20px;
}
.radish-dia-search {
  padding: 5px 0;
}
</style>
